export default __webpack_public_path__ + "static/media/drawing-man3-focusfill.9371c81b.svg";